import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AgGridModule } from 'ag-grid-angular';

import { CanEditSalesOrderPipe } from 'v2/modules/sales-order/pipes/can-edit-sales-order.pipe';
import { FeatureModule } from 'v2/shared/feature/feature.module';

import { MaterialCustomModule } from '../../material-custom.module';
import { SharedComponentsModule } from '../../shared-components.module';
import { ActivityLogComponent } from '../../standalone/activity-log/activity-log.component';
import { FulfillmentChannelControlComponent } from '../channel/components/fulfillment-channel-control/fulfillment-channel-control.component';
import { CustomFieldModule } from '../custom-field/custom-field.module';
import { FilterModule } from '../filter/filter.module';
import { RfqModule } from '../rfq/rfq.module';
import { AddressTransformationPipe } from '../shared/pipes/address-transformation.pipe';
import { PipeModule } from '../shared/pipes/pipe.module';
import { SharedModule } from '../shared/shared.module';
import { UiCopyableComponent } from '../ui/components/ui-copyable/ui-copyable.component';
import { UiModule } from '../ui/ui.module';

import { DirectiveModule } from './../shared/directives/directive.module';
import {
  OrderFulfillmentComponent,
  OrderFulfillmentItemsTableComponent,
  OrderFulfillmentStatusUpdateComponent,
  OrderOrderedItemsTableComponent,
  OrderPostedComponent,
  OrderPostedItemsTableComponent,
  OrderPostedPicklistPreviewComponent,
  OrderPostedTagsFormComponent,
  OrderRemoteOmsOrdersTableComponent,
  OrderReturnComponent,
  OrderReturnCreateComponent,
  OrderReturnDetailsComponent,
  OrderReturnFiltersComponent,
  OrderReturnFormComponent,
  OrderReturnItemTableComponent,
  OrderReturnTableComponent,
  OrderShipFormComponent,
  OrderShipFormV2Component,
  OrderShipmentsTableComponent,
  OrderShippingUpdatesComponent,
  OrderTransferComponent,
  OrderTransferFormComponent,
  OrderTransferLineItemsComponent,
  OrderTransferSkusComponent,
  OrderTransferTableComponent,
} from './components';
import { FulfillmentOrdersAgTableComponent } from './components/order-fulfillments-grid/components/fulfillment-orders-ag-table/fulfillment-orders-ag-table.component';
import { FulfillmentOrdersGridActionsComponent } from './components/order-fulfillments-grid/components/fulfillment-orders-grid-actions/fulfillment-orders-grid-actions.component';
import { OrderRefundReturnOrdersAgTableComponent } from './components/order-refund-return-orders-ag-table/order-refund-return-orders-ag-table.component';
import { ShipmentsAgTableComponent } from './components/order-shipments-grid/components/shipments-ag-table/shipments-ag-table.component';
import {
  OrderItemStatusLabelPipe,
  OrderTransferPurchaseOrderReceivedPipe,
} from './pipes';

const components = [
  OrderReturnFormComponent,
  OrderReturnDetailsComponent,
  OrderReturnItemTableComponent,
  OrderReturnCreateComponent,
  OrderReturnFiltersComponent,
  OrderReturnComponent,
  OrderReturnTableComponent,
  OrderPostedPicklistPreviewComponent,
  OrderPostedComponent,
  OrderPostedTagsFormComponent,
  OrderTransferFormComponent,
  OrderTransferSkusComponent,
  OrderTransferComponent,
  OrderTransferTableComponent,
  OrderTransferLineItemsComponent,
  OrderPostedItemsTableComponent,
  OrderShippingUpdatesComponent,
  OrderShipFormComponent,
  OrderShipFormV2Component,
  OrderShipmentsTableComponent,
  OrderRemoteOmsOrdersTableComponent,
  OrderFulfillmentComponent,
  OrderFulfillmentItemsTableComponent,
  OrderFulfillmentStatusUpdateComponent,
];

const angularModules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
];
const lumModules = [
  SharedComponentsModule,
  PipeModule,
  DirectiveModule,
  MaterialCustomModule,
  UiModule,
  FilterModule,
  RfqModule,
  DirectiveModule,
  CustomFieldModule,
  SharedModule,
];
const pipes = [OrderTransferPurchaseOrderReceivedPipe, OrderItemStatusLabelPipe];

@NgModule({
  declarations: [...components, ...pipes, OrderOrderedItemsTableComponent],
  imports: [
    ...angularModules,
    ...lumModules,
    FeatureModule,
    AgGridModule,
    ShipmentsAgTableComponent,
    FulfillmentOrdersAgTableComponent,
    OrderRefundReturnOrdersAgTableComponent,
    ActivityLogComponent,
    FulfillmentOrdersGridActionsComponent,
    FulfillmentChannelControlComponent,
    CanEditSalesOrderPipe,
    UiCopyableComponent,
    AddressTransformationPipe,
  ],
  exports: [...components],
  schemas: [NO_ERRORS_SCHEMA],
})
export class OrderModule {}
